var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46967 3.96967C8.76256 3.67678 9.23732 3.67678 9.53022 3.96967C9.82305 4.26257 9.82309 4.73734 9.53022 5.03022L5.56049 8.99994L9.53022 12.9697C9.82305 13.2626 9.82309 13.7373 9.53022 14.0302C9.23734 14.3231 8.76257 14.3231 8.46967 14.0302L3.96967 9.53022C3.67678 9.23732 3.67678 8.76256 3.96967 8.46967L8.46967 3.96967ZM12.9697 3.96967C13.2626 3.67678 13.7373 3.67678 14.0302 3.96967C14.3231 4.26257 14.3231 4.73734 14.0302 5.03022L10.0605 8.99994L14.0302 12.9697C14.3231 13.2626 14.3231 13.7373 14.0302 14.0302C13.7373 14.3231 13.2626 14.3231 12.9697 14.0302L8.46967 9.53022C8.17678 9.23732 8.17678 8.76256 8.46967 8.46967L12.9697 3.96967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronLeft);
export default __webpack_public_path__ + "static/media/double-chevron-left.ef57cc269d6b9e67d71f035000f71a3c.svg";
export { ForwardRef as ReactComponent };